import { render, staticRenderFns } from "./updatepwd.vue?vue&type=template&id=591f5114&"
import script from "./updatepwd.vue?vue&type=script&lang=js&"
export * from "./updatepwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports